import { AutocompleteFilter } from "./AutocompleteFilter";
import { UiCropFilterValue } from "portal/utils/categoryCollection/predictionPoints";
import { useCustomerEnabledCarbonCrops } from "portal/utils/hooks/useCustomerEnabledCarbonCrops";
import React, { FC } from "react";

interface CarbonCropFilterProps {
  customerUuid?: string;
  label: string;
  value: UiCropFilterValue[];
  onChange: (value: UiCropFilterValue[]) => void;
}

export const CarbonCropFilter: FC<CarbonCropFilterProps> = ({
  customerUuid,
  label,
  value,
  onChange,
}) => {
  const { crops, isFetching, isError, loadMore, onSearchInputChange } =
    useCustomerEnabledCarbonCrops({ customerUuid });

  return (
    <AutocompleteFilter
      loading={isFetching}
      loadingError={isError}
      label={label}
      options={crops ?? []}
      value={value}
      onChange={onChange}
      onLoadMore={loadMore}
      onSearchInputChange={onSearchInputChange}
    />
  );
};
